import Vue from "vue";

Vue.mixin({
	computed: {
		$isBlueBranding() {
			if (process.server) {
				return false;
			}

			const store = this.$store;
			if (!store || !store.state) {
				return false;
			}

			if (!store.state.features?.loaded) {
				return false;
			}

			return Boolean(this.isFeatureEnabled("BlueBranding"));
		},
	},
});
